const {
  appendPath,
  mutateValue,
  setContentValue
} = require('@truqc/content-path');
const {
  traverseFormContent
} = require('../lib/getFormContent');

// update the content of the form itself
const updateForm = async (formID, formContentPath, value, sourceEvaluator) => {
  const clearPatch = {};
  mutateValue(formContentPath, clearPatch, null);
  const setPatch = {};
  mutateValue(formContentPath, setPatch, value);
  const patchContentBehaviorSource = {
    type: 'patchContentBehavior',
    unsafePatch: true,
    id: formID,
    patches: [clearPatch, setPatch]
  };
  const result = await sourceEvaluator(patchContentBehaviorSource);
  return result;
};

// update the cached version of the form's content
const updateCache = async (formID, formContentPath, formContent, value, sourceEvaluator) => {
  const name = appendPath('formCache', formID);
  const newFormContent = setContentValue(formContentPath, formContent, value);
  const setCacheSource = {
    type: 'setCacheValueBehavior',
    name,
    value: newFormContent
  };
  await sourceEvaluator(setCacheSource);
};

/**
  * @function evalute - evaluate writeReferencedContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const {
    formID,
    formContent,
    formContentPath
  } = await traverseFormContent(source, content, parentContentPath, transientContext, nativeFunctions);
  if (formID !== undefined) {
    const value = await sourceEvaluator(source.value);
    const result = await updateForm(formID, formContentPath, value, sourceEvaluator);
    if (!result) {
      return;
    }
    await updateCache(formID, formContentPath, formContent, value, sourceEvaluator);
  }
};
module.exports = {
  evaluate
};